// @flow

/**
 * Return a promise that will be resolve
 * after the set time.
 * @param  {ms} miliseconds to wait (default 1s)
 * @return {Promise} resolved when time passed
 */
const delay = (ms: number = 1000): Promise<void> =>
  new Promise((r) => setTimeout(r, ms))

export default delay
